import { logger } from '../utils/logger/logger';
import ResponseTimeLogger from '../utils/responseTimeLogger/ResponseTimeLogger';

const defaultJsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
};

const defaultFileUploadHeaders = {
    Accept: 'application/json',
};

export const PostJson = async (url: string, body: Object, headers = defaultJsonHeaders): Promise<Object> => {
    const timeLog = new ResponseTimeLogger(url);
    const response = await fetch(url, {
        headers,
        method: 'POST',
        body: JSON.stringify(body),
    });
    return await processResponse(response, timeLog);
};

export const DeleteJson = async (url: string, headers = defaultJsonHeaders): Promise<Object> => {
    const timeLog = new ResponseTimeLogger(url);
    const response = await fetch(url, {
        headers,
        method: 'DELETE',
    });
    return await processResponse(response, timeLog);
};

export const GetJson = async (url: string, headers = defaultJsonHeaders): Promise<Object> => {
    const timeLog = new ResponseTimeLogger(url);
    const response = await fetch(url, {
        headers,
        method: 'GET',
    });
    return await processResponse(response, timeLog);
};

export const PostFiles = async (url: string, files: File[], headers = defaultFileUploadHeaders): Promise<Object> => {
    const timeLog = new ResponseTimeLogger(url);
    logger.info(`PostFiles posting to ${url}`, files);
    const formData = new FormData();
    files.forEach((file, index) => {
        if (file) {
            formData.append(`file${index}`, file);
        }
    });
    const response = await fetch(url, {
        headers,
        method: 'POST',
        body: formData,
    });
    return await processResponse(response, timeLog);
};

const processResponse = async (response: Response, timeLog: ResponseTimeLogger): Promise<Object> => {
    if (response.status >= 400) {
        throw new Error('An error occurred');
    }

    let responseData: Promise<Object>;
    try {
        responseData = await response.json();
    } catch {
        // Handle 204 response
        responseData = Promise.resolve({});
    } finally {
        timeLog.logNow();
        logger.info('Response received', responseData);
    }
    return responseData;
};
